import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIImage from 'UIComponents/image/UIImage';
import { OAuthToLogo, OAuthToText } from './OAuthMapping';
import { useState } from 'react';
import { useTracker } from '../tracking/useTracker';
import { useDispatch } from 'react-redux';
import { updateKeyValue } from '../store/app/action-creators';
import { AppKey } from '../app/AppKey';
import { MobileDims } from '../styling-utils/MobileAppDims';
import { useWidthMediaQueries } from '../responsiveness/useWidthMediaQueries';
import { ScreenSize } from '../responsiveness/MediaQuery';
import { StyledOAuthContainer, StyledOAuthButton, StyledOAuthImage, StyledOAuthText, StyledOAuthErrorMessage } from './OAuthButton.styles.ts';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { Step } from '../views/Step';
export const OAuthButton = ({
  oauth,
  onClick,
  isLoading = false
}) => {
  const [shouldRenderErrorMessage, setShouldRenderErrorMessage] = useState(false);
  const Tracker = useTracker();
  const dispatch = useDispatch();

  const onButtonClick = () => {
    Tracker.signupInteraction('click-oauth-button', {
      partner: oauth
    });
    dispatch(updateKeyValue(AppKey.FirstOAuthPartnerClick, oauth));

    if (onClick) {
      onClick();
    } else {
      setShouldRenderErrorMessage(true);
    }
  };

  const widthBreakpoint = useWidthMediaQueries();
  const shouldUpdateContainerStyle = widthBreakpoint < ScreenSize.SM;
  const logo = OAuthToLogo[oauth];
  const text = OAuthToText[oauth];
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(StyledOAuthContainer, {
      "data-selenium": 'oauth-container',
      style: shouldUpdateContainerStyle ? {
        width: `${MobileDims.width.LG}px`,
        padding: '2px 0px'
      } : {},
      children: /*#__PURE__*/_jsxs(StyledOAuthButton, {
        "data-selenium": `oauth-button-${oauth}`,
        disabled: shouldRenderErrorMessage,
        oAuth: oauth,
        onClick: onButtonClick,
        children: [logo && /*#__PURE__*/_jsx(StyledOAuthImage, {
          children: /*#__PURE__*/_jsx(UIImage, {
            className: `Image ${oauth}Image`,
            src: logo
          })
        }), text && /*#__PURE__*/_jsx(StyledOAuthText, {
          children: isLoading ? /*#__PURE__*/_jsx(UILoadingSpinner, {
            size: "sm"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: text
          })
        })]
      })
    }), shouldRenderErrorMessage && /*#__PURE__*/_jsxs(StyledOAuthErrorMessage, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: `views.${Step.LandingPage}.${oauth}Error`
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `views.${Step.LandingPage}.useEmailOrGoogle`
        })
      })]
    })]
  });
};